// extracted by mini-css-extract-plugin
module.exports = {"tags":"_9e1425b4d3--tags--Ht5Ze","tags_wrapper":"_9e1425b4d3--tags_wrapper--h3HCz","tags_item":"_9e1425b4d3--tags_item--_jrWb"};